// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2R711","inputWrap":"Table_inputWrap__19dxA","col":"Table_col__2LK3l","bmiTooltip":"Table_bmiTooltip__BEGqO"};